module.exports = __webpack_public_path__ + "img/payway-img.8a406a0e.png";